import Link from "next/link";
import Image from "next/image";
import { Props } from "./types";
import Hamburger from "@/atoms/Hamburger";
import routes from "@/constants/routes";
import MovedInHeader from "@/components/dashboard/OfferPage/MovedInPage/Header";

const Header = ({
  className,
  isLoginLayout = false,
  noAccount = false,
  showHamburger = true,
  text = "Start your application",
  navigationExpanded,
  toggleNavigation,
  isMovedIn,
  mainIconLink,
}: Props): JSX.Element => {
  return (
    <>
      {!isMovedIn ? (
        <nav
          className={`fixed z-50 flex items-center w-screen h-[72px] md:h-20 px-6 py-3 ${
            isMovedIn ? "bg-white text-lightGray md:px-4" : "bg-grey-800 md:px-16"
          }  ${className}`}
        >
          <div className="flex items-center justify-between w-full justify-items-start">
            <Link href={mainIconLink || "/"}>
              <a className="relative w-32 h-9 lg:w-44 lg:h-12">
                <Image src="/shared/keyzy-horizontal.svg" alt="keyzy logo" layout="fill" priority />
              </a>
            </Link>

            <p className="hidden text-lg font-bold tracking-widest uppercase md:inline-block absolute-center-xy text-grey-300">
              {text}
            </p>
            {!isLoginLayout && (
              <>
                {showHamburger && (
                  <Hamburger
                    open={navigationExpanded}
                    onClick={toggleNavigation}
                    className="inline-block lg:hidden"
                    theme="dark"
                  />
                )}

                {!noAccount && (
                  <Link href={routes.dashboard.manageAccount}>
                    <a className="text-lg font-bold text-white lg:flex">
                      Your account{" "}
                      <div className="hidden lg:flex lg:ml-3 ">
                        <Image
                          src="/icons/people.svg"
                          alt="account"
                          width={24}
                          height={24}
                          className="mb-[3px]"
                        />
                      </div>
                    </a>
                  </Link>
                )}
              </>
            )}
          </div>
        </nav>
      ) : (
        <MovedInHeader />
      )}
    </>
  );
};

export default Header;
